import React, { useState } from 'react';
import { withAppContext } from '@ctsu/loader';
import bindLogger from 'helpers/BindLogger';
import { getSignCtepID } from 'actions/irb';
import TypeAhead from './TypeAhead';

function SignatoryTypeAhead({
  ctepId, context, onChange, value, ...rest
}) {
  const [options, setOptions] = useState([]);

  const fetchOptions = (searchText) => {
    if (searchText == null || searchText.trim().length < 3) {
      setOptions([]);
      return;
    }

    if (ctepId != null) {
      bindLogger(getSignCtepID, context)(ctepId, searchText).subscribe((resp) => {
        const { response } = resp;
        if (response != null && response.length > 0) {
          setOptions(
            response.map((r) => {
              const { siteCtepId, siteName } = r;
              return {
                label: `${siteCtepId} | ${siteName}`,
                value: siteCtepId,
                sigSiteName: siteName
              };
            })
          );
        }
      });
    }
  };

  return (
    <TypeAhead
      name="Signatory CTEP"
      value={value}
      options={options}
      onChange={onChange}
      onChangeText={fetchOptions}
      {...rest}
    />
  );
}

export default withAppContext(SignatoryTypeAhead);
